import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import ErrorContentBody from './ErrorContentBody';
import styles from './errors.module.scss';

const ErrorContent = () => (
  <div className={styles.container}>
    <ErrorContentBody />
    <div className={styles.buttonContainer}>
      <Button
        linkInfo={{ href: '/explore' }}
        text={<FormattedMessage defaultMessage="Find your next trail" />}
        type="button"
        size="md"
        variant="primary"
      />
    </div>
  </div>
);

export default ErrorContent;
